var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.1 40.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,11.8v16.5c0,.7.4,1.2.9,1.2h21.7c.5,0,.9-.5.9-1.2V11.8c0-.7-.4-1.2-.9-1.2H9.4c-.5,0-.9.5-.9,1.2Z",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10.6,
    x2: 20,
    y2: 29.7,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 20.1,
    x2: 32,
    y2: 20.1,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1,
    y1: 13.1,
    x2: 14.1,
    y2: 17.5,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.9,
    y1: 15.3,
    x2: 16.3,
    y2: 15.3,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.9,
    y1: 24,
    x2: 16.3,
    y2: 24,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.9,
    y1: 26,
    x2: 16.3,
    y2: 26,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8,
    y1: 23.4,
    x2: 24.6,
    y2: 26.5,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.6,
    y1: 23.4,
    x2: 27.8,
    y2: 26.5,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.2,
    y1: 15.3,
    x2: 28.2,
    y2: 15.3,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.c97865a79bdc09109102878ab4bfbd84.svg";
export { ForwardRef as ReactComponent };